import translate, { formatNumber } from '@/services/translate';
import Http from '@/services/http';
import { fieldsDefinitions } from '@/domain/data/installation/engineering/physicalChemical/sample';
import { PhysicalChemicalSample, PhysicalChemicalSampleGet } from 'sigma-mappings';
import {
  formatter as dateTimeFormatter,
  getNow,
} from '@/services/dateTime/datetimeService';
import msis127Error from '@/domain/data/installation/engineering/cromaMSIS127ErrorHandler';

const urls = {
  base: assetModuleId => `/engenharia/${assetModuleId}/fisico-quimico/amostras`,
  byId: (assetModuleId, sampleId) => `${urls.base(assetModuleId)}/${sampleId}`,
};

/* istanbul ignore next */
function getNumberFormatOptions(decimal) {
  if (decimal == null) return null;
  return {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  };
}

/* istanbul ignore next */
const getFieldNameRule = ({ field }) => {
  const actualField = fieldsDefinitions[field];
  return {
    NomeDoCampo: translate(actualField.name),
  };
};

/* istanbul ignore next */
const dateOrNumberFormatter = ({ field }) => {
  const actualField = fieldsDefinitions[field];
  if (actualField == null) {
    return null;
  }
  let faixaInicial = null;
  let faixaFinal = null;
  if (actualField.isDate) {
    faixaInicial = dateTimeFormatter(actualField.min);
    faixaFinal = dateTimeFormatter(getNow());
  } else {
    faixaInicial = formatNumber(actualField.min, getNumberFormatOptions(actualField.decimal));
    faixaFinal = formatNumber(actualField.max, getNumberFormatOptions(actualField.decimal));
  }
  return {
    FaixaInicial: faixaInicial,
    FaixaFinal: faixaFinal,
    NomeDoCampo: translate(actualField.name, {
      temperature: actualField.temperature,
    }),
  };
};

const { msis127ErrorHandler, errorHandling } = msis127Error;

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA005: getFieldNameRule,
      $MA010: ({ field }) => {
        const actualField = fieldsDefinitions[field];
        return {
          NomeDoCampo: translate(actualField.name),
          NroCaracteres: formatNumber(actualField.min),
        };
      },
      $MA029: dateOrNumberFormatter,
      $ME037: data => data,
      $MA038: dateOrNumberFormatter,
      $ME045: data => data,
      $MA058: ({ field }) => {
        const actualField = fieldsDefinitions[field];
        return {
          NomeDoCampo: translate(actualField.name),
          NroCaracteres: formatNumber(actualField.max),
        };
      },
      $MA059: getFieldNameRule,
    },
    ...errorHandling,
  },
};

export default {
  get(assetModuleId, sampleId) {
    const http = new Http(error);
    return http.get(urls.byId(assetModuleId, sampleId))
      .then(({ data }) => new PhysicalChemicalSampleGet(data.laudos.ensaios))
      .catch(msis127ErrorHandler);
  },
  insert(assetModuleId, sample) {
    const http = new Http(error);
    return http.post(urls.base(assetModuleId), new PhysicalChemicalSample.MapBack(sample));
  },
  update(assetModuleId, sampleId, sample) {
    const http = new Http(error);
    return http.put(
      urls.byId(assetModuleId, sampleId),
      new PhysicalChemicalSample.MapBack(sample),
    ).catch(msis127ErrorHandler);
  },
};
